import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators,compose } from "redux";
import {  withRouter } from "react-router-dom";
import ModalCardOk from "../ModalCardOk";
import { formatRawCurrency, isObjectEmpty } from "../../organisms/utils";
import { getMessengerService, getAmountOfTelcelPospago } from "../../../store/actions";
import { getMessage } from "../../organisms/utils";
import { executeTaggeo } from "../../../store/actions";
import { setFromActionValue } from "../../../store/actions/domiciliation";
import { formatCurrency } from "../../organisms/utils";
import { setMaxAmountValue } from "../../../store/actions/domiciliation";
import { roundAmount } from "../../organisms/GenericForm/utils/formatToCurrency";

export default class HasDomiciliationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openHasDomiciliationModal: false,
      CpMessage: "CP0005",
    };
  }

  componentDidMount() {
    const {
      hasDmError,
      hasDmResponse,
      getMessengerService,
      history,
      accountValue,
      amount,
      tagServiceId,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue,
      getAmountOfTelcelPospago,
      serviceId,
      isContainerTelcel,
    } = this.props;
    let alertId = "";
    getMessengerService("PagosProgramados");
    if (!isObjectEmpty(hasDmResponse) && hasDmResponse.data) {
      const {
        data: { domiciliation },
      } = hasDmResponse;
      if (domiciliation) {
        setTimeout(() => {
          this.setState({
            openHasDomiciliationModal: true,
            CpMessage: "CP0014",
          });
        }, 400);

        alertId = "Servicio con pago ya domiciliado";
      } else {
        getAmountOfTelcelPospago(
          accountValue,
          serviceId,
          true
        );
        setFromActionValue("clickButtonDomiciliation")
        setMaxAmountValue(formatRawCurrency(roundAmount(amount.replace(/(,)/gm, ""))))
        setTimeout(() => {
          history.push({
            pathname: `schedule-telcel-bill-payments`,
            state: { accountValue, amount, tagServiceId },
          });
        }, 200);
      }
    }
    if (hasDmError) {
      getMessengerService("PagosProgramados");
      setTimeout(() => {
        this.setState({ CpMessage: "CP0013", openHasDomiciliationModal: true });
      }, 400);
      alertId = "Domiciliación no completada";
    }
    setTimeout(() => {
      executeTaggeo({
        action: "View alert",
        step:
          tagServiceId === "serviciopagotelcelMenu"
            ? "Pantalla principal"
            : "Formulario de pago",
        service: tagServiceId,
        alert_id: alertId,
        eventName:
          tagServiceId === "serviciopagotelcelMenu"
            ? "telcel"
            : "pay_service_or_tae",
      });
    }, 800);
  }

  handleOnclickModal = () => {
    const { tagServiceId, executeTaggeo, hasDmError } = this.props;
    this.setState({ openHasDomiciliationModal: false });
    executeTaggeo({
      action: "Click alert Entendido",
      service: tagServiceId,
      step:
        tagServiceId === "serviciopagotelcelMenu"
          ? "Pantalla principal"
          : "Formulario de pago",
      alert_id: hasDmError
        ? "Domiciliación no completada"
        : "Servicio con pago ya domiciliado",
      eventName:
        tagServiceId === "serviciopagotelcelMenu"
          ? "telcel"
          : "pay_service_or_tae",
    });
  };

  render() {
    const { openHasDomiciliationModal, CpMessage } = this.state;
    const { messagesDomiciliation, isContainerTelcel } = this.props;
    let messageInformation = { data: {} };
    if (messagesDomiciliation.length !== 0) {
      messageInformation = getMessage(messagesDomiciliation, CpMessage);
    }
    return (
      <ModalCardOk
        isOpen={openHasDomiciliationModal}
        srcImage={messageInformation.data.icon}
        text={messageInformation.data.subject}
        textdetail={messageInformation.data.message}
        fontFamilyTextdetail={"AMX-Regular"}
        fontSizeDetail={isContainerTelcel ? "16px" : undefined}
        colorTextdetail={isContainerTelcel ? "#757575" : undefined}
        marginTextDetail={isContainerTelcel ? "16px 0px 35px 0px" : undefined}
        buttontext={"Entendido"}
        widthButton={isContainerTelcel ? "95%" : undefined}
        fontFamilyButton={"AMX-Bold"}
        fontSizeButton={isContainerTelcel ? "16px" : undefined}
        colorButton={isContainerTelcel ? "#ffffff" : undefined}
        backgroundColorButton={isContainerTelcel ? "#7B1FA2" : undefined}
        heightButton={isContainerTelcel ? "43px" : undefined}
        paddingButton={isContainerTelcel ? "2px 0px 0px 0px" : undefined}
        onclickModal={this.handleOnclickModal}
        fontSizeTitle={isContainerTelcel ? "20px" : "18px"}
        fontFamilyTitle={"AMX-Bold"}
        paddingCard={isContainerTelcel ? "16px 36px 50px 36px" : undefined}
        marginButton={isContainerTelcel ? "0px auto" : undefined}
      />
    );
  }
}

function mapStateToProps(state) {
  const { domiciliationReducer: { messagesDomiciliation } = [], payments } =
    state;
  return {
    messagesDomiciliation,
    isContainerTelcel: payments.isContainerTelcel,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getMessengerService,
      executeTaggeo,
      setFromActionValue,
      setMaxAmountValue,
      getAmountOfTelcelPospago,
    },
    dispatch
  );
}

HasDomiciliationModal = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(HasDomiciliationModal);
